import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Code } from 'lucide-react';
import { projects } from '../data/projects';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ProjectDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const project = projects.find(p => p.id === parseInt(id));

  const handleBackClick = () => {
    navigate('/#projects');
  };

  if (!project) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-black">
        <div className="text-center">
          <h2 className="mb-4 text-2xl font-bold text-white">Project Not Found</h2>
          <button onClick={() => navigate('/')} className="text-blue-400 hover:text-blue-300">
            Go Back Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="px-4 pb-20 pt-24 sm:px-6 lg:px-8">
        <div className="container mx-auto max-w-4xl">
          <motion.button
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={handleBackClick}
            className="mb-8 flex items-center gap-2 text-gray-400 transition-colors hover:text-white"
          >
            <ArrowLeft className="h-5 w-5" />
            Back to Projects
          </motion.button>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md"
          >
            <div className="p-6 md:p-8">
              {/* Header Section */}
              <div className="mb-6 flex items-start gap-4">
                <div className="rounded-lg bg-gradient-to-br from-blue-500/20 to-red-500/20 p-2">
                  <Code className="h-5 w-5 text-blue-400" />
                </div>
                <div className="flex-1">
                  <h1 className="mb-4 text-2xl font-bold leading-tight text-white md:text-3xl">
                    {project.title}
                  </h1>
                  <p className="mb-4 text-lg text-gray-300">{project.description}</p>
                </div>
              </div>

              {/* Content Section */}
              <div className="space-y-6">
                <div>
                  <h2 className="mb-2 text-lg font-semibold text-white">Overview</h2>
                  <p className="leading-relaxed text-gray-300">{project.longDescription}</p>
                </div>

                <div>
                  <h2 className="mb-3 text-lg font-semibold text-white">Technologies</h2>
                  <div className="flex flex-wrap gap-2">
                    {project.technologies.map((tech, idx) => (
                      <span
                        key={idx}
                        className="rounded-lg border border-blue-500/30 bg-gradient-to-r from-blue-500/20 to-red-500/20 px-3 py-1.5 text-sm text-blue-300"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProjectDetails;
